import { useRef } from 'react'

/**
 * @param callback - The function to throttle.
 * @param delay - The throttle delay in ms.
 */
// eslint-disable-next-line
function useThrottledCallback<T extends (...args: any[]) => ReturnType<T> | undefined>(callback: T, delay: number) {
    const lastRun = useRef(0)

    return (...args: Parameters<T>) => {
        const now = Date.now()

        if (now - lastRun.current >= delay) {
            callback(...args)
            lastRun.current = now
        }
    }
}

export default useThrottledCallback
